module.exports = __webpack_public_path__ + "img/Pic_ZHBG_YS_d.5076394f.gif";